import { useEffect, useRef } from 'react';

const MultiSelectDropdown = ({
  label = 'Select Subject',
  options = [],
  selectedValues = [],
  onSelectionChange,
  isOpen = false,
  setIsOpen,
  onToggleDropdown,
  className = '',
  hasAllOption = true,
}) => {
  const dropdownRef = useRef();

  const getDisplayText = () => {
    if (selectedValues.includes('all') && hasAllOption) {
      return 'All Selected';
    }

    if (selectedValues.length === 0) {
      return 'None selected';
    }

    if (selectedValues.length === 1) {
      const selected = options.find((opt) => opt.id === selectedValues[0]);
      return selected ? selected.name : '1 selected';
    }

    return `${selectedValues.length} selected`;
  };

  const handleSelect = (id) => {
    if (!onSelectionChange) return;

    let newSelection = [...selectedValues];

    if (id === 'all' && hasAllOption) {
      if (!selectedValues.includes('all')) {
        newSelection = ['all'];
      } else {
        newSelection = [];
      }
    } else {
      if (selectedValues.includes(id)) {
        newSelection = newSelection.filter((val) => val !== id);
      } else {
        newSelection = newSelection.filter((val) => val !== 'all');
        newSelection.push(id);
      }
    }

    onSelectionChange(newSelection);
  };
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Handle escape key press
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    // Add event listeners if dropdown is open
    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
      document.addEventListener('keydown', handleEscKey);
    }

    // Clean up event listeners
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, setIsOpen]);

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <button
        onClick={onToggleDropdown}
        className="flex !h-full w-full items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-3 hover:cursor-pointer"
      >
        <div className="flex flex-col items-start gap-2">
          <span className="text-sm tracking-[-0.28px] text-[#012E33]">{label}</span>
          <span className="text-base font-medium tracking-[-0.16px] text-[#012E33]">
            {getDisplayText()}
          </span>
        </div>
        <img src="/images/icons/chevron-down-outline.svg" alt="" />
      </button>

      {isOpen && (
        <div
          className="absolute z-10 mt-1 w-full rounded-2xl bg-white  shadow-lg scrollbar-hide"
          style={{ maxHeight: '300px', overflowY: 'auto' }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="flex cursor-pointer items-center px-3 py-2 hover:bg-gray-50"
              onClick={() => handleSelect(option.id)}
            >
              <div
                className={`mr-3 flex h-5 w-5 items-center justify-center rounded ${selectedValues.includes(option.id) ? 'bg-[#FC823E]' : 'border border-gray-300'}`}
              >
                {selectedValues.includes(option.id) && (
                  <img src="/images/icons/Check-white.svg" alt="checkmark" className="h-4 w-4" />
                )}
              </div>
              <span className="font-medium text-gray-800">{option.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
